import { render, staticRenderFns } from "./ResponseType5.vue?vue&type=template&id=36730ad7&scoped=true&"
import script from "./ResponseType5.vue?vue&type=script&lang=js&"
export * from "./ResponseType5.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType5.vue?vue&type=style&index=0&id=36730ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36730ad7",
  null
  
)

export default component.exports